// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE component-icon/src/svgtoreact.sh TO MODIFY
import React from 'react';
import PropTypes from 'prop-types';

var RegistrarLogo = function RegistrarLogo(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      className: className,
      "aria-label": label,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    },
    /*#__PURE__*/
    React.createElement("g", {
      opacity: ".5"
    },
    /*#__PURE__*/
    React.createElement("path", {
      d: "M8 .25A7.75 7.75 0 00.439 6.294h15.122A7.75 7.75 0 008 .25zM8 15.75a7.75 7.75 0 007.561-6.044H.439A7.752 7.752 0 008 15.75z"
    })),
    /*#__PURE__*/
    React.createElement("path", {
      d: "M8.898 9.048l.444-1.881.443 1.881h.551l.348-1.243.346 1.243h.551l.494-2.096h-.625l-.211 1.237-.327-1.237h-.455l-.332 1.265-.209-1.265H8.767l-.211 1.237-.33-1.237h-.455l-.332 1.265-.206-1.265H6.084l-.211 1.237-.327-1.237h-.455l-.332 1.265-.209-1.265h-.625l.494 2.096h.551l.348-1.243.346 1.243h.551l.443-1.881.444 1.881h.551l.348-1.243.346 1.243h.551zM3.4 4.535H1.067a7.693 7.693 0 00-.628 1.759H3.05a12.636 12.636 0 01.35-1.759zM4.983.859a7.775 7.775 0 00-3.607 3.116h2.185A14.561 14.561 0 014.983.859zM14.624 3.975A7.775 7.775 0 0010.993.849a14.552 14.552 0 011.428 3.126zM10.153.553A7.746 7.746 0 008.2.253v3.722h3.68A13.563 13.563 0 0010.153.553zM7.638 3.975V.258a7.736 7.736 0 00-1.813.3A13.543 13.543 0 004.1 3.975zM3.569 6.294h4.069V4.535H3.927a11.8 11.8 0 00-.358 1.759zM12.931 6.294h2.63a7.693 7.693 0 00-.627-1.758h-2.348a12.621 12.621 0 01.345 1.758zM12.053 4.535H8.2v1.759h4.214a11.828 11.828 0 00-.361-1.759zM12.379 11.514h2.405a.276.276 0 01.112.024 7.694 7.694 0 00.664-1.832h-2.713a11.819 11.819 0 01-.468 1.808zM4.179 11.514h3.459V9.706H3.674a11.392 11.392 0 00.505 1.808zM3.134 9.706H.439a7.688 7.688 0 00.652 1.808H3.6a11.781 11.781 0 01-.466-1.808zM8.195 11.514h3.6a11.367 11.367 0 00.5-1.808h-4.1zM8.195 12.074v3.673a7.782 7.782 0 001.223-.127l.162-.235c.022-.036.049-.077.074-.11a14.273 14.273 0 001.923-3.2zM6.321 15.273c.03.038.11.151.11.151s.067.094.132.193a7.763 7.763 0 001.075.125v-3.668H4.4a14.274 14.274 0 001.921 3.199zM10.251 15.418a7.764 7.764 0 004.343-3.344h-2.423a14.234 14.234 0 01-1.92 3.344zM1.407 12.074a7.769 7.769 0 004.317 3.336 14.3 14.3 0 01-1.914-3.336z"
    }))
  );
};

export default RegistrarLogo;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/RegistrarLogo.js
// module id = 1041
// module chunks = 0